import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MainService } from "../../../services/main/main.service";
import { AuthService } from "../../../services/auth/auth.service";
import * as REGEX from '../../../shared/regex';
import { getUserProfile, getUserProfiles } from 'src/app/core/session';

@Component({
  selector: "app-office",
  templateUrl: "./office.component.html",
  styleUrls: ["./office.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class OfficeComponent implements OnInit {
  salutations = ["Dr.", "Mr.", "Ms.", "Mrs.", "Miss."];
  public mask = REGEX.mobile_mask;
  public zip_mask = REGEX.zip_mask;
  isSubmitting: boolean;
  managerProfile: UntypedFormGroup;
  profile: any;
  constructor(private fb: UntypedFormBuilder,
    public mainService: MainService,
    private authService: AuthService) {
  }
  ngOnInit() {
    this.profile = localStorage.getItem('userProfileData') && getUserProfiles() && getUserProfile() && getUserProfile();
    this.initForm();
    this.getValues();
  }

  initForm(){
    this.managerProfile = this.fb.group({
      manager_name: [""],
      manager_title: ["None"],
      manager_email: [""],
      manager_mobile: [""],
    })
  }

  getValues() {
    if (this.profile) {
      let managerProfile = {
        manager_name: this.profile.manager_name,
        manager_title: this.profile.manager_title || "None",
        manager_email: this.profile.manager_email,
        manager_mobile: this.profile.manager_mobile !== "" ? parseInt(this.profile.manager_mobile.split("-")[1]) : '',
      };
      this.managerProfile.patchValue(managerProfile);
    }
  }

  updateOfficeData() {
    let data = this.managerProfile.value;
    if (data.manager_mobile !== "" && !new RegExp(/^[0-9]+$/).test(data.manager_mobile)) {
      this.mainService.customPopups('Please enter valid mobile number', 1);
      return
    }

    if (data.manager_mobile == '0000000000') {
      this.mainService.customPopups('Please enter valid mobile number', 1);
      return;
    }

    if (data.manager_email !== "" && !new RegExp(REGEX.email_regex).test(data.manager_email)) {
      this.mainService.customPopups('Please enter valid email', 1);
      return
    }

    let token = localStorage.getItem('token');
    let formdata = {};
    formdata['access_token'] = token
    formdata['manager_name'] = data.manager_name
    formdata['manager_title'] = data.manager_title || "None"
    formdata['manager_email'] = data.manager_email
    formdata['manager_mobile'] = data.manager_mobile !== "" ? ('+1-' + data.manager_mobile.toString().replace(/[{()}-]/g)).toString() : ''
    this.mainService
      .uploadApi(formdata, "edit_manager", true)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.mainService.customPopups('Office details updated successfully', 0)
          this.getOtherProfile();
          this.managerProfile.markAsPristine();
        }
      });


  }

  async getOtherProfile() {
    try {
      await this.authService.accessTokenLogin();
    } catch (error) {
      console.log(error)
    }
  }

}
